var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24.5C18.6274 24.5 24 19.1274 24 12.5C24 5.87258 18.6274 0.5 12 0.5C5.37258 0.5 0 5.87258 0 12.5C0 19.1274 5.37258 24.5 12 24.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0849 6.12004L13.484 6.11719C11.6861 6.11719 10.5242 7.32584 10.5242 9.1966V10.6165H8.91472C8.77581 10.6165 8.66309 10.7309 8.66309 10.8721V12.929C8.66309 13.0702 8.77581 13.1841 8.91472 13.1841H10.5242V18.3751C10.5242 18.5163 10.6369 18.6301 10.7758 18.6301H12.8754C13.0144 18.6301 13.1271 18.5157 13.1271 18.3751V13.1841H15.0087C15.1476 13.1841 15.2603 13.0696 15.2603 12.929L15.2609 10.8721C15.2609 10.8043 15.2341 10.7394 15.1874 10.6916C15.1402 10.6438 15.0758 10.6165 15.0092 10.6165H13.1271V9.41295C13.1271 8.83452 13.2631 8.54077 14.0061 8.54077H15.0844C15.2233 8.54077 15.336 8.42634 15.336 8.28572V6.37564C15.336 6.23445 15.2239 6.12061 15.0849 6.12004Z",
    fill: "#3B5998"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.37190df0101d005e37fe2a43c8e26c35.svg";
export { ForwardRef as ReactComponent };